import { render, staticRenderFns, recyclableRender, components } from "./u-swiper-indicator.vue?vue&type=template&id=647f6c67&scoped=true&"
var renderjs
import script from "./u-swiper-indicator.vue?vue&type=script&lang=js&"
export * from "./u-swiper-indicator.vue?vue&type=script&lang=js&"
import style0 from "./u-swiper-indicator.vue?vue&type=style&index=0&id=647f6c67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647f6c67",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "node_modules/uview-ui/components/u-swiper-indicator/u-swiper-indicator.vue"
export default component.exports